module.exports = __webpack_public_path__ + "static/img/gaozhongdili6.2ef991f2.jpg";